// module.exports = {
//   // 地区的随机码
//   license: 'ik9YaoxW'   //泉州
//   //  license: 'u83QpK'   //十堰
// }
import router from '@/router'
const license = () => process.env.VUE_APP_IS_LOCAL_HERF && router.currentRoute.query && router.currentRoute.query.license

export {
  license
}